import React, { useEffect, useState } from "react";

// reactstrap components
import {
	Card,
	CardHeader,
	CardBody,
	Table,
	FormGroup,
	Label,
	Input,
	Collapse,
	Row,
	Col,
	Button
} from "reactstrap";
import { Link } from "react-router-dom";
import * as moment from "moment";

import { DISTRICTS, STATES } from '../../configs/urls'
import { getApi, deleteApi } from '../../services/api'

import Loader from '../../components/Loader'
import Toaster from "../../components/Toaster";

import './styles.css'
import { FaEdit } from 'react-icons/fa'
import axios from 'axios'
import { STATUS_LIST, DATE_FORMATS, PAGE_LIMIT, MESSAGES } from '../../configs/constant'

const Districts = () => {

	const [isRequesting, setIsRequestig] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [canShowLoadMore, setCanShowLoadMore] = useState(false);

	const [districts, setDistricts] = useState([])
	const [isFilterOpen, setIsFilterOpen] = useState(false)
	const [filterParams, setFilterParams] = useState({
		page: 0,
		size: PAGE_LIMIT
	})
	const [states, setStates] = useState([])

	useEffect(() => {
		getAllData()
	}, [])

	const getAllData = () => {
		const states = getApi(STATES);
		const districts = getApi(DISTRICTS, filterParams);

		axios
			.all([states, districts])
			.then((res) => {

				if (res[0] && res[0].data) {
					setStates(res[0].data)
					setFilterParams({
						...filterParams,
						state_id: 20
					})
				}

				if (res[1] && res[1].data) {
					setDistricts(res[1].data)
					setCanShowLoadMore(res[1].data.length < res[1].meta.total)
				}
			})
			.catch(() => {

			}).finally(() => {
				setIsRequestig(false)
			})
	}

	const fetchDistricts = (isLoadMore) => {
		const params = JSON.parse(JSON.stringify(filterParams))

		setIsLoading(true);

		for (const key in params) {
			if ((!params[key] && params[key] != 0) || params[key] == -1) {
				delete params[key]
			}
		}

		getApi(DISTRICTS, params)
			.then((res) => {
				let districtsData = isLoadMore ? [...districts, ...res.data] : res.data;
				setDistricts(districtsData)
				setCanShowLoadMore(districtsData.length < res.meta.total)
			}, (err) => {
				console.log(err);
			}).finally(() => {
				setIsLoading(false);
			})
	}

	const deleteDistrict = (districtId) => {
		var proceed = window.confirm("Are you sure you want to delete disrict?");
		if (proceed) {
			deleteApi(`${DISTRICTS}/${districtId}`)
				.then((res) => {
					let list = districts
					list = list.filter(item => item.id != districtId)
					setDistricts(list)
					Toaster.showSuccess(res.message || 'District deleted successfully.')
				}, (err) => {
					Toaster.showError(err.message)
				})
		}
	}

	const handleChange = (event) => {
		event.persist();
		setFilterParams(values => ({ ...values, [event.target.name]: event.target.value }));
	};

	const resetFilter = () => {
		setFilterParams({
			state_id: -1,
			status: -1,
			name: '',
			page: 0,
			size: PAGE_LIMIT
		});

		fetchDistricts();
	}

	const searchDistricts = () => {
		const params = filterParams;
		params.page = 0;

		setFilterParams(params)

		fetchDistricts();
	}

	const loadMoreDistricts = () => {
		const params = filterParams;
		params.page++;

		setFilterParams(params)

		fetchDistricts(true);
	}

	const renderDistricts = () => (
		<div className="content">
			<Row>
				<Col md="12">
					<Card>
						<CardHeader className="header-section">
							<div>
								<Button color="primary" onClick={() => setIsFilterOpen(!isFilterOpen)}>Filter</Button>
							</div>
							<Link to="districts/operations">
								<Button color="primary" className="text-right">Add New District</Button>
							</Link>
						</CardHeader>

						<Collapse isOpen={isFilterOpen} className="border-top">
							<Card>
								<CardBody>
									<Row>
										<Col className="pr-1" md="3">
											<FormGroup>
												<label>District</label>
												<Input
													type="text"
													name="name"
													placeholder="District Name"
													value={filterParams.name || ""}
													onChange={handleChange}
												/>
											</FormGroup>
										</Col>
										<Col className="pr-1" md="3">
											<FormGroup>
												<Label for="stateName">State</Label>
												<Input
													type="select"
													name="state_id"
													value={filterParams.state_id}
													onChange={handleChange}
												>
													<option value={-1}>Select State</option>
													{
														states.map(state => (
															<option key={state.id} value={state.id}>{state.name}</option>
														))
													}
												</Input>
											</FormGroup>
										</Col>
										<Col className="pr-1" md="3">
											<FormGroup>
												<Label for="status">Status</Label>
												<Input
													type="select"
													name="status"
													value={filterParams.status}
													onChange={handleChange}
												>
													{
														STATUS_LIST.map(status => (
															<option key={status.id} value={status.id}>{status.title}</option>
														))
													}
												</Input>
											</FormGroup>
										</Col>
										<Col className="pr-1" md="3">
											<div className="update ml-auto mt-3 mr-auto">
												<Button className="btn-round" onClick={() => searchDistricts()} color="primary">
													Search
												</Button>
												<Button className="btn-round ml-2" onClick={() => resetFilter()} color="primary">
													Reset
												</Button>
											</div>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Collapse>

						<hr />
						<CardBody>
							<Table>
								<thead className="text-primary">
									<tr>
										<th>ID</th>
										<th>District name</th>
										<th>State</th>
										<th>Status</th>
										<th>Last Update</th>
										<th className="text-right">Actions</th>
									</tr>
								</thead>
								<tbody>
									{
										districts.map(district => (
											<tr key={district.id}>
												<td>{district.id}</td>
												<td>{district.name || '--'}</td>
												<td>{district.state ? district.state.name : '--'}</td>
												<td>{district.status == 1 ? 'Enabled' : 'Disabled'}</td>
												<td>{district.updated_at ? moment(district.updated_at).format(DATE_FORMATS.DATE_TIME_FORMAT) : '--'}</td>
												<td className="text-right action-icons">
													<Link to={`districts/operations/${district.id}`}>
														<FaEdit />
													</Link>
												</td>
											</tr>
										))
									}
								</tbody>
							</Table>
							{
								districts.length == 0 &&
								<span className="no-record-found">{MESSAGES.NO_RECORD_FOUND}</span>
							}
						</CardBody>
					</Card>
				</Col>
			</Row>
			{
				canShowLoadMore && 
				<Row>
					<Col className="load-more-col">
						<Button className="action-btn" onClick={() => loadMoreDistricts()} color="primary">Load more</Button>
					</Col>
				</Row>
			}
			<Loader isLoading={isLoading} />
		</div>
	)

	return (
		<>
			{
				isRequesting
					? <div className="content"><Loader isLoading={isRequesting} /></div>
					: renderDistricts()
			}
		</>
	);
}

export default Districts;
